import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../../Core/RichText';
import ProductIconText from '../../../Optimum/OptimumProductCards/ProductIconText';

import { Card, Header, Body, Icon } from './style';

const Feature = ({ data }) => {
  if (!data) return null;

  const { backgroundColor, heading, bodyCopy, imageDam, cardClassName } = data;

  const body = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <>{children}</>,
      [BLOCKS.EMBEDDED_ENTRY]: node => {
        const { data: segment } = node;
        if (
          segment.target.__typename === 'ContentfulTitleOrImageWithIconLists'
        ) {
          return <ProductIconText data={segment.target} className="features" />;
        }
        return null;
      },
    },
  };

  return (
    <Card $borderColor={cardClassName} $bgColor={backgroundColor}>
      <Header>
        {imageDam && <Icon src={imageDam} />}
        {heading && <RichText document={heading} />}
      </Header>
      <Body>{bodyCopy && <RichText document={bodyCopy} options={body} />}</Body>
    </Card>
  );
};

Feature.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default Feature;
